import axios from './../index';
const {
  get,
  post,
  put,
  del,
  getStream
} = axios;
const externalUrl = "/external"; // 头部设置

export function getOpenPageDom(domain) {
  return get(`${externalUrl}/api/v1/domains`);
}